import { objectIsEmpty, getParamsStringFromUrl } from './helpers';

const categoryId = () => getParamsStringFromUrl('category_id');

const PROMOTION_CONTENT_IDS_URL = `${window.location.pathname}/stream`;
const PROMOTIONS_URL = `${window.location.pathname}/promotions?ids=`;

const addEmptyItems = (_array, itemsPerPage) => {
  let array = _array;
  const extraItem = array.length % itemsPerPage;
  const itemsToAppend = itemsPerPage - extraItem;

  if ((extraItem !== 0) && (itemsToAppend > 0)) {
    for (let i = 0; i < itemsToAppend; i += 1) {
      array = array.concat({});
    }
  }

  return array;
};

export default class Promotions {
  constructor(options = {}) {
    if (!options.fetcher) throw new Error('no Fetcher found');

    this.promotionsIds = [];
    this.promotionsIdsPointer = 0;
    this.preloadItems = [];
    this.signature = null;
    this.firstFetch = true;
     
    this.options = {
      perItems: 1,
      preloadItems: 2,
      ...options,
    };
  }

  ready() {
    const {
      fetcher,
      preloadItems,
      perItems,
    } = this.options;

    const promotionsUrl = `${PROMOTION_CONTENT_IDS_URL}${(!preloadItems) ? '' : `?preload=${preloadItems}`}${categoryId()}`;

    return fetcher({
      type: 'GET',
      url: promotionsUrl,
    }).then((jsonData) => {
      const ids = jsonData.ids || [];

      const promotionsIds = ids.map(id => ({
        id,
      }));

      this.promotionsIds = addEmptyItems(promotionsIds, perItems);

      this.preloadItems = jsonData.preloaded;

      this.signature = jsonData.signature;

      return Promise.resolve(true);
    });
  }

  setPerItems(data) {
    const promotionsIdsWithoutEmpty = this.promotionsIds
      .filter(promotionId => !objectIsEmpty(promotionId));

    this.promotionsIds = addEmptyItems(promotionsIdsWithoutEmpty, data);
    this.options.perItems = data;
  }

  promotionsLength() {
    return this.promotionsIds.length;
  }

  isLastPromotions(promotionsIds) {
    const promotionsIdsWithoutEmpty = promotionsIds.reduce(
      (acc, cur) => ((cur !== null) ? acc.concat(cur) : acc),
      [],
    );

    const promotionsIdsFromPromotions = this.promotionsIds.reduce(
      (acc, cur) =>
        ((!objectIsEmpty(cur)) ? acc.concat(cur.id) : acc),
      [],
    );
    return promotionsIdsWithoutEmpty[promotionsIdsWithoutEmpty.length - 1] ===
      promotionsIdsFromPromotions[promotionsIdsFromPromotions.length - 1];
  }

  getItems({ withPreload }) {
    const {
      perItems,
      fetcher,
    } = this.options;

    const promotionsIdsPerItems = withPreload ?
      this.promotionsIdsPointer + this.options.preloadItems :
      this.promotionsIdsPointer + perItems;

    const selectedIdsWithEmpty = this.promotionsIds.slice(
      this.promotionsIdsPointer,
      promotionsIdsPerItems,
    );

    const selectedIds = selectedIdsWithEmpty.reduce(
      (acc, cur) =>
        ((!objectIsEmpty(cur)) ? acc.concat(cur.id) : acc),
      [],
    );

    const emptyObjects = selectedIdsWithEmpty.filter(id => objectIsEmpty(id));

    if (selectedIds.length === 0) {
      return Promise.resolve({
        promotionsIds: selectedIds,
        promotions: emptyObjects,
      });
    }

    if (
      (this.preloadItems.length > 0) &&
      (this.promotionsIdsPointer <= this.options.preloadItems)
    ) {
      const items = this.preloadItems.filter(item => selectedIds.indexOf(item.id) !== -1);
      this.preloadItems = this.preloadItems.filter(item => selectedIds.indexOf(item.id) === -1);
      this.promotionsIdsPointer += withPreload ? this.options.preloadItems : perItems;

      return Promise.resolve({
        promotionsIds: selectedIds,
        promotions: items.concat(emptyObjects),
      });
    }

    this.promotionsIdsPointer += perItems;

    return fetcher({
      type: 'GET',
      url: `${PROMOTIONS_URL}${selectedIds.join(',')}`,
    }).then((jsonData) => {
      return Promise.resolve({
        promotionsIds: selectedIds,
        promotions: jsonData.concat(emptyObjects),
      });
    });
  }
}
